module.exports = __webpack_public_path__ + "static/media/ottawa-4.99a6e514.jpg";